import { Stack, Typography } from '@mui/material';
import type { Account } from '@repo/api-gw-sdk';

import { CloudProviderIndicator } from '@/components/cloudProviderIndicator';
import { PanelWrapper } from '@/components/panels/panelWrapper';
import type { useDAL } from '@/contexts/useDAL';

import { AccountJobMetrics } from '../accountJobMetrics';

interface MetricsProps {
  account: Account;
  onAbort: () => void;
  getMetricConfiguration: () => ReturnType<
    ReturnType<typeof useDAL>['cloudAccounts'][
      | 'restore'
      | 'source']['metrics']['get']
  >;
  enableMetrics: (account: Account, region: string) => Promise<void>;
  disableMetrics: (account: Account) => Promise<void>;
}

export function MetricsPanel(props: MetricsProps) {
  return (
    <PanelWrapper
      testIdPrefix='edit-metrics-panel'
      header={{
        title: 'Edit metrics',
        subtitle: (
          <Stack className='px-[20px]' gap='24px'>
            <CloudProviderIndicator
              cloudProvider={props.account.cloudProvider}
              text={props.account.providerAccountId}
            />
            <Typography className='max-w-[680px]' variant='body1'>
              Control which metrics are published to your AWS CloudWatch account
              to power dashboards, alarms, and insights.
            </Typography>
          </Stack>
        ),
        onBack: props.onAbort,
        onClose: props.onAbort,
      }}
    >
      <AccountJobMetrics
        account={props.account}
        onClose={props.onAbort}
        getMetricConfiguration={props.getMetricConfiguration}
        enableMetrics={props.enableMetrics}
        disableMetrics={props.disableMetrics}
      />
    </PanelWrapper>
  );
}
